import {Box, Button, Grid, Stack, Typography} from '@mui/material';
import {useObservable} from '@ngneat/react-rxjs';
import {useSnackbar} from 'notistack';
import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';

import {Indexation, indexationQuery, indexationService} from '@store/settings/indexation';

import {Add} from '@icons/index';
import IndexationDetailsModal from '@screens/admin/settings/indexation/indexationDetails/IndexationDetails.modal';
import IndexationInfosCard from '@screens/admin/settings/indexation/IndexationInfos.card';
import IndexationRatesHistoryModal from '@screens/admin/settings/indexation/indexationRatesHistory/IndexationRatesHistory.modal';
import ManageIndexationModal from '@screens/admin/settings/indexation/manageIndexation/ManageIndexation.modal';

import {Colors} from '@constants/colors.constants';

const IndexationTab = () => {
  const {t} = useTranslation();
  const {enqueueSnackbar} = useSnackbar();

  const [showCreate, setShowCreate] = useState(false);
  const [detailsIndexation, setDetailsIndexation] = useState<Indexation | undefined>(undefined);
  const [historyIndexation, setHistoryIndexation] = useState<Indexation | undefined>(undefined);

  const [{indexations}] = useObservable(indexationQuery.indexations$);

  useEffect(() => {
    indexationService.getIndexations().subscribe({
      error: (err) => enqueueSnackbar(err.text, err.options),
    });
  }, [enqueueSnackbar]);

  return (
    <>
      <Stack flex={1} spacing={1} p="25px" overflow="hidden">
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography fontSize="30px" fontWeight="700">
            {t('routes.indexations')}
          </Typography>
          <Button
            variant="contained"
            color="primary"
            startIcon={<Add/>}
            onClick={() => setShowCreate(true)}>
            {t('settings.indexation.drawer.title')}
          </Button>
        </Stack>
        <Box flex={1} pt="25px" overflow="hidden">
          <Stack height="100%" overflow="hidden" borderRadius="4px" bgcolor={Colors.white}>
            <Stack p="30px" overflow="auto" className="scrollable">
              <Grid container spacing={2} columns={6}>
                {indexations?.map((indexation) => (
                  <Grid item key={indexation.id} xs={2}>
                    <IndexationInfosCard
                      indexation={indexation}
                      onShowDetails={() => setDetailsIndexation(indexation)}
                      onShowHistory={() => setHistoryIndexation(indexation)}/>
                  </Grid>
                ))}
              </Grid>
            </Stack>
          </Stack>
        </Box>
      </Stack>
      {showCreate && (
        <ManageIndexationModal handleClose={() => setShowCreate(false)}/>
      )}
      {detailsIndexation && (
        <IndexationDetailsModal
          indexation={detailsIndexation}
          handleClose={() => setDetailsIndexation(undefined)}/>
      )}
      {historyIndexation && (
        <IndexationRatesHistoryModal
          indexation={historyIndexation}
          handleClose={() => setHistoryIndexation(undefined)}/>
      )}
    </>
  );
};

export default IndexationTab;